import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import avatar from 'flarum/common/helpers/avatar';
import icon from 'flarum/common/helpers/icon';
import LinkButton from 'flarum/common/components/LinkButton';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import LogInModal from 'flarum/forum/components/LogInModal';
import NotificationsDropdown from 'flarum/forum/components/NotificationsDropdown';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';

class MobileSessionDropdown extends SessionDropdown {
  getButtonContent() {
    return [
      avatar(app.session.user),
      <span className="Button-label">
        {app.translator.trans('space-pocket-posts.forum.bottom_nav.account')}
      </span>,
    ];
  }

  items() {
    const items = super.items();

    if (app.flags) {
      items.add(
        'flags',
        <LinkButton icon="fas fa-flag" href={app.route('flags')}>
          {app.translator.trans('space-pocket-posts.forum.bottom_nav.flags')}
        </LinkButton>,
        25
      );
    }

    return items;
  }
}

export default class MobileBottomNav extends Component {
  startDiscussion(event) {
    event.preventDefault();

    if (!app.forum.attribute('canStartDiscussion')) return;

    const indexButton = document.querySelector('.IndexPage-newDiscussion');

    if (indexButton) {
      indexButton.click();
      return;
    }

    app.composer.load(DiscussionComposer, { user: app.session.user });
    app.composer.show();
  }

  dropdown(component, state, label, className) {
    if (!component || !state) return <span className="SpacePocketPosts-bottomNavUnavailable" />;

    return m(component, {
      state,
      label,
      accessibleToggleLabel: label,
      className,
      buttonClassName: 'Button Button--flat SpacePocketPosts-bottomNavButton',
      menuClassName: 'SpacePocketPosts-bottomDropdownMenu',
    });
  }

  loginRequired(iconName, label) {
    return (
      <button
        type="button"
        className="Button Button--flat LogInButton SpacePocketPosts-bottomNavButton"
        aria-label={label}
        onclick={() => this.logIn()}
      >
        {icon(iconName, { className: 'Button-icon' })}
        <span className="Button-label">{label}</span>
      </button>
    );
  }

  logIn() {
    app.modal.show(LogInModal);
  }

  view() {
    const searchRoute = app.route('spacePocketSearch');
    const showSearchButton = m.route.get().split('?')[0] !== searchRoute;
    const searchButton = showSearchButton ? (
      <LinkButton
        className="Button Button--icon SpacePocketPosts-mobileSearchButton"
        icon="fas fa-search"
        href={searchRoute}
        aria-label={app.translator.trans('space-pocket-posts.forum.bottom_nav.search')}
        title={app.translator.trans('space-pocket-posts.forum.bottom_nav.search')}
      />
    ) : null;

    const user = app.session && app.session.user;
    const DraftsDropdown = user ? flarum.extensions['fof-drafts']?.components?.DraftsDropdown : null;
    const draftsLabel = app.translator.trans('space-pocket-posts.forum.bottom_nav.drafts');
    const notificationsLabel = app.translator.trans('space-pocket-posts.forum.bottom_nav.notifications');
    const accountLabel = app.translator.trans('space-pocket-posts.forum.bottom_nav.account');

    return [
      searchButton,
      <nav
        className="SpacePocketPosts-bottomNav"
        aria-label={app.translator.trans('space-pocket-posts.forum.bottom_nav.label')}
      >
        <ul className="SpacePocketPosts-bottomNavItems">
          <li className="SpacePocketPosts-bottomNavItem item-home">
            <LinkButton
              className="Button Button--flat SpacePocketPosts-bottomNavButton"
              icon="fas fa-home"
              href={app.route('index')}
            >
              {app.translator.trans('space-pocket-posts.forum.bottom_nav.home')}
            </LinkButton>
          </li>
          <li className="SpacePocketPosts-bottomNavItem item-drafts">
            {user
              ? this.dropdown(
                  DraftsDropdown,
                  app.drafts,
                  draftsLabel,
                  'SpacePocketPosts-bottomDropdown SpacePocketPosts-bottomDrafts'
                )
              : this.loginRequired('fas fa-edit', draftsLabel)}
          </li>
          <li className="SpacePocketPosts-bottomNavItem item-compose">
            {user ? (
              <button
                type="button"
                className="Button SpacePocketPosts-bottomCompose"
                aria-label={app.translator.trans('space-pocket-posts.forum.bottom_nav.compose')}
                disabled={!app.forum.attribute('canStartDiscussion')}
                onclick={(event) => this.startDiscussion(event)}
              >
                {icon('fas fa-plus')}
              </button>
            ) : (
              <button
                type="button"
                className="Button LogInButton SpacePocketPosts-bottomCompose"
                aria-label={app.translator.trans('core.forum.header.log_in_link')}
                onclick={() => this.logIn()}
              >
                {icon('fas fa-plus')}
              </button>
            )}
          </li>
          <li className="SpacePocketPosts-bottomNavItem item-notifications">
            {user ? (
              <NotificationsDropdown
                state={app.notifications}
                label={notificationsLabel}
                accessibleToggleLabel={notificationsLabel}
                className="SpacePocketPosts-bottomDropdown SpacePocketPosts-bottomNotifications"
                buttonClassName="Button Button--flat SpacePocketPosts-bottomNavButton"
                menuClassName="SpacePocketPosts-bottomDropdownMenu"
              />
            ) : (
              this.loginRequired('fas fa-bell', notificationsLabel)
            )}
          </li>
          <li className="SpacePocketPosts-bottomNavItem item-session">
            {user ? (
              <MobileSessionDropdown />
            ) : (
              <button
                type="button"
                className="Button Button--flat LogInButton SpacePocketPosts-bottomNavButton"
                aria-label={app.translator.trans('core.forum.header.log_in_link')}
                onclick={() => this.logIn()}
              >
                {icon('fas fa-user', { className: 'Button-icon' })}
                <span className="Button-label">{accountLabel}</span>
              </button>
            )}
          </li>
        </ul>
      </nav>,
    ];
  }
}
